import Helper from '@ember/component/helper';
import { observer } from '@ember/object';
import { service } from '@ember/service';

import type { SafeString } from '@ember/template';
import type { FormatMessageParameters } from 'ember-intl/-private/formatjs';

import type { NamedArgs, PositionalArgs } from 'ember-modifier';
import type LabelService from 'volta/services/label-service';

interface TElseSignature<T extends boolean = false> {
  Args: {
    Positional: [translation?: string | SafeString, fallback?: string | SafeString];
    Named:
      | (FormatMessageParameters[1] & {
          htmlSafe?: T;
          locale?: string;
        })
      | undefined;
  };
  Return: T extends true ? SafeString : string;
}

export default class TElseHelper extends Helper<TElseSignature> {
  @service labelService!: LabelService;

  // eslint-disable-next-line ember/no-observers
  onLocaleChange = observer('localization.intl.locale', () => {
    this.recompute();
  });

  compute<T extends boolean = false>(
    [translation, fallback]: PositionalArgs<TElseSignature<T>>,
    options: NamedArgs<TElseSignature<T>>
  ): T extends true ? SafeString : string {
    if (!translation) {
      return (fallback ?? '') as T extends true ? SafeString : string;
    }
    return this.labelService.tOrElse(translation, fallback, options);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    't-else': typeof TElseHelper;
  }
}
